import { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '../../Widgets/Select.react';
import moment from 'moment';


export default class MealTypesInfo extends Component {

    static propTypes = {
        mealType: PropTypes.object,
        patient: PropTypes.object,
        onChange: PropTypes.func,
        error: PropTypes.object
    }

    constructor(props) {
        super(props);

        const { mealType } = this.props;

        const {
            name,
            keywords,
            max_time,
            max_cost,
            main_dish,
            begin,
            end,
            participants,
        } = mealType;

        this.state = {
            name,
            keywords,
            max_time,
            max_cost,
            main_dish,
            begin,
            end,
            participants,
        };
    }

    updateMealType = () => {
        const { onChange, mealType } = this.props;
        const updatedMealType = {...mealType, ...this.state};
        onChange(updatedMealType);
    }

    generateTimeOptions = () => {
        const options = [];
        const pad = (num) => (num < 10 ? '0' : '') + num;
    
        for (let h = 0; h < 24; h++) {
            for (let m = 0; m < 60; m += 15) {
                const hour = h % 12 === 0 ? 12 : h % 12;
                const ampm = h < 12 ? 'AM' : 'PM';
                const label = `${pad(hour)}:${pad(m)} ${ampm}`;
                const value = h * 60 + m;
                options.push({ value, label });
            }
        }
        return options;
    };

    deduceTimeForMealType = (startTimeInMinutes) => {
        const midnightTime = moment('00:00', 'HH:mm');
        const currentTime = midnightTime.add(startTimeInMinutes, 'minutes');
        const formattedCurrentTime = (startTimeInMinutes % 60 === 0) ? currentTime.format('h a') : currentTime.format('h:mm a');
        return formattedCurrentTime;
    }

    toggleParticipants = (participant) => {
        const { participants } = this.state;
        let updatedParticipants;
        if(participants.includes(participant)) {
            updatedParticipants = participants.filter((uuid) => uuid !== participant);
        } else {
            updatedParticipants = [...participants, participant];
        }
        this.setState({participants: updatedParticipants}, this.updateMealType);
    }

    render() {
        const {
            name,
            keywords,
            max_time,
            max_cost,
            main_dish,
            begin,
            end,
            participants,
        } = this.state;

        const { patient, error } = this.props;
        const { first_name, family } = patient;
        const allParticipants = [{uuid: 'USER', name: first_name}].concat(family.map((member) => ({uuid: member.uuid, name: member.name})));

        const maxTimeOptions = [
            {label: 'No limit', value: null},
            {label: 'Under 15 Minutes', value: 900},
            {label: 'Under 30 Minutes', value: 1800},
            {label: 'Under 45 Minutes', value: 2700},
            {label: 'Under 1 Hour', value: 3600},
        ];

        const maxCostMinimumValue = {
            'Breakfast': 3.25,
            'Lunch': 5,
            'Snacks': 3,
            'Dinner': 5
        }

        const tyepOptions = [
            {value: "Breakfast", label: "Breakfast"},
            {value: "Lunch", label: "Lunch"},
            {value: "Snack", label: "Snack"},
            {value: "Dinner", label: "Dinner"},
        ]

        const timeOptions = this.generateTimeOptions();

        return (
            <div className="meal-type-info" data-testid={`meal-type-info-${name}`}>
                <div className="el-labeled-input el-select-box-2 inline el-inline-raspberry-input meal-type" data-error={error === `${name}-meal-type`}>
                    <label>Meal Name:</label>
                    <input type="text" value={name} maxLength={25}
                        onChange={(event) => this.setState({name: event.target.value})}
                        onBlur={this.updateMealType} />
                </div>
                <div className="el-labeled-input el-select-box-2 inline type">
                    <label>Meal Type:</label>
                    <span>{main_dish}</span>
                </div>
                <div className="el-labeled-input inline el-raspberry-dropdown max-time">
                    <label>Max Time:</label>
                    <Select
                        defaultClassName="el-select-container"
                        disableTypeAhead={true}
                        value={max_time || null}
                        options={maxTimeOptions}
                        onChange={(value) => this.setState({ max_time: value }, this.updateMealType)}
                    />
                </div>
                <div className="el-labeled-input inline el-raspberry-numeric-input max-cost" data-error={error === `${name}-max-cost`}>
                    <label>Max Cost:</label>
                    <div>
                        <span>$ </span>
                        <input
                            type="number"
                            value={max_cost}
                            min={maxCostMinimumValue[main_dish] || 5}
                            max={99999}
                            step={0.5}
                            placeholder="No Limit"
                            onChange={(event) => {
                                const value = parseFloat(event.target.value);
                                const max_cost = isNaN(value) ? null : value;
                                this.setState({ max_cost });
                            }}
                            onBlur={this.updateMealType}
                        />
                    </div>
                </div>
                <div className="el-labeled-input inline el-raspberry-dropdown time">
                    <label>Time:</label>
                    <span>
                        <Select
                            defaultClassName="el-select-container"
                            value={begin}
                            options={timeOptions}
                            onChange={(value) => this.setState({ begin: value }, this.updateMealType)}
                        />
                        {"  -  "}
                        <Select
                            defaultClassName="el-select-container"
                            value={end}
                            options={timeOptions}
                            onChange={(value) => this.setState({ end: value }, this.updateMealType)}
                        />
                    </span>
                </div>
                <div className="el-labeled-input el-select-box-2 inline keywords">
                    <label>Preferences for this meal:</label>
                    <input type="text" placeholder={`Enter foods e.g. "smoothie", "salads"`} value={keywords}
                        onChange={(event) => this.setState({keywords: event.target.value})}
                        onBlur={this.updateMealType} />
                </div>
                <div className="el-labeled-input el-select-box-2 participants">
                    <label>Who is eating this meal?</label>
                    {allParticipants?.map((member) => (
                        <div key={member.uuid} className="participant">
                            <button
                                className="el-off-switch"
                                data-active={
                                    participants?.includes(member.uuid)
                                }
                                onClick={() =>
                                    this.toggleParticipants(member.uuid)
                                }
                            >
                            {member.name}
                            <span>{participants?.includes(member.uuid) ? "on" : "off"}</span>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
